import type { VoidFunctionComponent } from 'react';

import { Icon, icons } from '../../../generic/Icon';
import Link from '../../../generic/Link/Link';

import styles from './FossabotBlockedCaption.module.less';

/** Why fossabot cannot open a PR for this dependency, and where to read more. */
export type FossabotBlockedCaptionProps = {
  text: string;
  linkText: string;
  href: string;
};

/**
 * The row at the bottom of the Remediation card, under the standard remediation
 * cards, when fossabot cannot open a PR for this dependency.
 */
export const FossabotBlockedCaption: VoidFunctionComponent<FossabotBlockedCaptionProps> = ({ text, linkText, href }) => (
  <div className={styles.caption} data-testid="fossabot-blocked-caption">
    <span className={styles.icon}>
      <Icon icon={icons.circleInfo} />
    </span>
    <span>
      {text}{' '}
      <Link to={href} openInNewTab>
        <span className={styles.link}>{linkText}</span>
      </Link>
    </span>
  </div>
);
